<label>Journey progress products</label>
<div>
    <small class="text-muted">Only products with defined categories are selectable here</small>
</div>
<dx-tag-box class="select-progress-products"
            [items]="templateProgressProducts"
            [value]="progressProductIds"
            (valueChange)="onValueChanged($event)"
            [showSelectionControls]="true"
            applyValueMode="instantly"
            [displayExpr]="progressProductDisplayExpr"
            valueExpr="progressProductId"
            [showDropDownButton]="true"></dx-tag-box>

@if (organisation && existingProducts.length > 0) {
    <div class="alert alert-danger mt-3 mb-0">
        The following progress products already exist in the organisation:
        <ul>
            @for (product of existingProducts; track product.progressProductId) {
                <li>{{product.name}} (code <code>{{product.code}}</code>)</li>
            }
        </ul>
    </div>
}
